<template>
  <div class="initial-loading">
    <div class="loading-content">
      <!-- Breathing Logo -->
      <div class="logo-container">
        <div class="logo-glow" :class="{ 'is-visible': imageLoaded }"></div>
        <img :src="logoSrc"
             alt="Regularizei"
             class="breathing-logo"
             :class="{ 'is-visible': imageLoaded }"
             @load="onImageLoad">
      </div>

      <!-- Loading Text -->
      <p class="loading-text" :class="{ 'is-visible': imageLoaded }">
        Carregando seus projetos...
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CONFIG from '~config/env'

export default {
  name: 'RegInitialLoading',

  data() {
    return {
      imageLoaded: false
    }
  },

  computed: {
    ...mapState({
      initialDataLoaded: state => state.initialDataLoaded
    }),
    logoSrc() {
      return this.$getWhitelabelUI('navLogo')?.fullPath || require('@/assets/regularizei_logo.png')
    }
  },

  watch: {
    initialDataLoaded() {
      if (this.initialDataLoaded) {
        this.redirectToNext()
      }
    }
  },

  mounted() {
    // Preload da imagem
    this.preloadImage()

    if (this.initialDataLoaded) {
      this.redirectToNext()
    }
  },

  methods: {
    preloadImage() {
      const img = new Image()
      img.onload = () => {
        this.imageLoaded = true
      }
      img.onerror = () => {
        // Em caso de erro, mostra mesmo assim para não travar
        this.imageLoaded = true
      }
      img.src = this.logoSrc
    },

    onImageLoad() {
      this.imageLoaded = true
    },

    redirectToNext() {
      if (this.$route.query.next) {
        this.$router.push(this.$route.query.next)
      } else {
        this.$router.push(CONFIG.FIRST_SCREEN_AFTER_LOGIN)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.initial-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.logo-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  min-height: 180px;
}

.logo-glow {
  position: absolute;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(25, 118, 210, 0.15) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;

  &.is-visible {
    opacity: 0.6;
    animation: glow-pulse 2.5s ease-in-out infinite;
  }
}

.breathing-logo {
  position: relative;
  max-width: 120px;
  max-height: 120px;
  width: auto;
  height: auto;
  object-fit: contain;
  opacity: 0;
  transform: scale(0.95);
  transition: opacity 0.4s ease, transform 0.4s ease;
  filter: drop-shadow(0 4px 20px rgba(25, 118, 210, 0.1));

  &.is-visible {
    opacity: 1;
    transform: scale(1);
    animation: breathe 2.5s ease-in-out infinite;
    animation-delay: 0.4s;
  }
}

.loading-text {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #94a3b8;
  letter-spacing: 0.02em;
  margin: 0;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.4s ease 0.2s, transform 0.4s ease 0.2s;

  &.is-visible {
    opacity: 0.7;
    transform: translateY(0);
    animation: text-fade 2.5s ease-in-out infinite;
    animation-delay: 0.6s;
  }
}

/* Breathing Animation */
@keyframes breathe {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.85;
  }
}

/* Glow Pulse Animation */
@keyframes glow-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.15);
    opacity: 1;
  }
}

/* Text Fade Animation */
@keyframes text-fade {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}
</style>
